module.exports = require("./fr-MR.js");